import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../Login/LoginPage";
import BookDemoPage from "../BookDemo/BookDemoPage";
import SelectMenuPage from "../SelectMenu/SelectMenuPage";
import ResultsPage from "../Results/ResultsPage";
import { PrivateRoute } from "../../Shared/PrivateRoute";
import CreatePage from "../CreateProject/CreatePage";
import ConfigurationPage from "../Configuration/ConfigurationPage";
import DataManagementPage from "../DataManagement/DataManagementPage";
import UserSettingsPage from "../User/UserSettings/userSettings";
import ProjectReportPage from "../ProjectReport/ProjectReport";
import ProjectReportOverviewPage from "../ProjectReportOverview/ProjectReportOverview";
import GraphsOverviewPage from "../Graphs/GraphsOverviewPage";
import GraphDetailPage from "../Graphs/GraphDetailPage";
import ModifyGraphPage from "../Graphs/ModifyGraphPage";
import ViewGraphPage from "../Graphs/ViewGraphPage";
import ModifyPage from "../ModifyProject/ModifyPage";
import PerformMeasurementPage from "../PerformMeasurement/PerformMeasurementPage";
import ManagePage from "../ProjectOverview/ManagePage";
import DuplicatePage from "../DuplicateProject/DuplicatePage";
import CreateListPage from "../CreateList/CreateList";
import CreateExternalApiPage from "../CreateExternalApi/CreateExternalApi";
import ModifyListPage from "../ModifyList/ModifyList";
import ModifyExternalApiPage from "../ModifyExternalApi/ModifyExternalApi";
import PrivacyPolicyPage from "../PrivacyPolicy/PrivacyPolicyPage";
import ListOverviewPage from "../ProjectListOverview/ListOverview";
import ExternalApiOverviewPage from "../ExternalApiListOverview/ExternalApiOverview";
import CompanySettingsPage from "../CompanyManagment/CompanySettings";
import AccountOverviewPage from "../AccountOverview/AccountOverview";
import SubscriberOverviewPage from "../SubscriptionManagement/SubscriberOverviewPage";
import GeneralLedgerAccountPage from "../GeneralLedgerAccount/GeneralLedgerAccountPage";
import { Roles } from "../../../Config/constants";

import LandingPage from "../Landing/LandingPage";
import PricingPage from "../Pricing/PricingPage";
import FinancialCenterPage from "../FinancialCenter/FinancialCenterPage";
import QrScannerPage from "../QrScanner/QrScannerPage";

function NavigationPage(props) {
  const loggedInState = props.Login.loginState;
  const isTaplrAdmin = props.Login.isTaplrAdmin;

  return (
    <React.Fragment>
      <Routes>
        {loggedInState && (
          <Route
            path="/"
            loggedInState={loggedInState}
            element={
              <PrivateRoute {...props}>
                {" "}
                <SelectMenuPage {...props}></SelectMenuPage>{" "}
              </PrivateRoute>
            }
          ></Route>
        )}
        <Route
          path="/user"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <UserSettingsPage {...props}></UserSettingsPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/create"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <CreatePage {...props}></CreatePage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/datamanagement"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <DataManagementPage {...props}></DataManagementPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/financialcenter"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              <FinancialCenterPage {...props}></FinancialCenterPage>
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/modifydropdown/:dropdownUniqueId"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ModifyListPage {...props}></ModifyListPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/createdropdown"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <CreateListPage {...props}></CreateListPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/projectreport/:projectQr"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ProjectReportPage {...props}></ProjectReportPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/projectreportoverview"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ProjectReportOverviewPage {...props}></ProjectReportOverviewPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/createapi"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <CreateExternalApiPage {...props}></CreateExternalApiPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/modifyapi/:apiUniqueId"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ModifyExternalApiPage {...props}></ModifyExternalApiPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/dropdownoverview"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ListOverviewPage {...props}></ListOverviewPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/externalapioverview"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ExternalApiOverviewPage {...props}></ExternalApiOverviewPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/graphs"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <GraphsOverviewPage {...props}></GraphsOverviewPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/modifygraph/:graphId"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ModifyGraphPage {...props}></ModifyGraphPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/graph/:graphId"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <GraphDetailPage {...props}></GraphDetailPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/modify"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ModifyPage {...props}></ModifyPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/modifyproject/:projectQr"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ModifyPage {...props}></ModifyPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/scanqr"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <LoginPage {...props}></LoginPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/results"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ResultsPage {...props}></ResultsPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/results/:projectQr"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ResultsPage {...props}></ResultsPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/manage"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ManagePage {...props}></ManagePage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/duplicate/:projectQr"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <DuplicatePage {...props}></DuplicatePage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/configuration"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <ConfigurationPage {...props}></ConfigurationPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/company"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              {" "}
              <CompanySettingsPage {...props}></CompanySettingsPage>{" "}
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/accountoverview"
          loggedInState={loggedInState}
          element={
            <PrivateRoute {...props}>
              <AccountOverviewPage {...props}></AccountOverviewPage>
            </PrivateRoute>
          }
        ></Route>
        <Route path="/subscriptionmanagement" loggedInState={loggedInState} element={<PrivateRoute {...props}>{isTaplrAdmin && <SubscriberOverviewPage {...props} />}</PrivateRoute>} />
        {/* <Route path="/generalledgeraccount" loggedInState={loggedInState} element={<PrivateRoute {...props}><GeneralLedgerAccountPage {...props}></GeneralLedgerAccountPage></PrivateRoute>}></Route> */}
      </Routes>
      <Routes>
        <Route path="/login" exact loggedInState={loggedInState} element={<LoginPage {...props} />} />
        <Route path="/measure" loggedInState={loggedInState} element={<PerformMeasurementPage loggedInState={loggedInState} {...props} />} />
        <Route path="/viewgraph/:graphId" loggedInState={loggedInState} element={<ViewGraphPage {...props}></ViewGraphPage>}></Route>
        <Route path="/" exact loggedInState={loggedInState} element={!loggedInState && <LandingPage {...props} />} />
        <Route path="/bookdemo" exact loggedInState={loggedInState} element={<BookDemoPage {...props} />} />
        <Route path="/privacypolicy" exact loggedInState={loggedInState} element={<PrivacyPolicyPage {...props} />} />
        <Route path="/pricing" exact loggedInState={loggedInState} element={<PricingPage {...props} />} />
        <Route path="/scanner" exact loggedInState={loggedInState} element={<QrScannerPage />} />
      </Routes>
    </React.Fragment>
  );
}

export default NavigationPage;
